module.exports = __webpack_public_path__ + "static/media/fightscout-web-new.7192de30.png";